module.exports = __webpack_public_path__ + "img/yoga2.fdcebc31.jpg";